// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rkofajl{border-radius:var(--ds-radius-small,3px)}._18m915vq{overflow-y:hidden}\n._18u0idpf{margin-left:0}\n._19pk1n1a{margin-top:-1px}\n._1e0c1o8l{display:inline-block}\n._1reo15vq{overflow-x:hidden}\n._2hwxidpf{margin-right:0}\n._bfhkttw1{background-color:var(--ds-border,#f7f7f7)}\n._kqswh2mm{position:relative}\n._o5721q9c{white-space:nowrap}\n._otyr1n1a{margin-bottom:-1px}\n._s7n4nkob{vertical-align:middle}\n._y3gn1h6o{text-align:center}", ""]);
// Exports
module.exports = exports;
